export let lifeline = {};
lifeline.userDetails = lifeline.userDetails || {};
lifeline.pageUrl = window.location.href;

export const orgIdHeaderKey = 'X-ORG-CHANNEL-ID';

export const PRODUCTION_HOST = 'lifeline.blinkit.com';
export const PREPROD_HOSTS = [
  'lifeline.blinkit.dev',
  'lifeline-dashboard-crm.preprod.blinkit.dev',
];
